// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatsappOverlay_container__1VKXB"};